<template>
  <v-select
    v-model="$data[opts.key]"
    :name="opts.key"
    :items="opts.values"
    :item-text="item => item.name[$i18n.locale]"
    :item-value="'id'"
    :label="label"
    :placeholder="opts.placeholder || this.$t('bots.selectField') + ' ' + label"
    :error-messages="errorMessages"
    @change="$v[opts.key].$touch()"
    @blur="$v[opts.key].$touch()"
  >
    <template v-slot:append>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        {{ description }}
      </v-tooltip>
    </template>
  </v-select>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SelectInput",
  mixins: [validationMixin],
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      }
    },
    config: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    let data = {};
    let key = this.opts.key;
    data[key] = this.opts.value || null;
    return data;
  },
  computed: {
    label() {
      return (
        this.opts.name[this.$i18n.locale] +
        (this.opts.required != undefined && this.opts.required == true
          ? "*"
          : "")
      );
    },
    description() {
      return this.opts.description[this.$i18n.locale];
    },
    errorMessages() {
      const errors = [];
      if (this.$v[this.opts.key] != undefined) {
        if (!this.$v[this.opts.key].$dirty) return errors;
        this.$v[this.opts.key].required !== undefined &&
          !this.$v[this.opts.key].required &&
          errors.push(this.$t("profile.reqField"));
      }
      return errors;
    }
  },
  watch: {
    opts: {
      handler({value, key}) {
        if(value && key) {
          this[key] = value;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.config != null) this.$data[this.opts.key] = this.config;
  },
  methods: {},
  validations() {
    let validation = {};
    if (this.opts.validate != undefined && !_.isEmpty(this.opts.validate)) {
      validation[this.opts.key] = {
        required
      };
    }
    return validation;
  }
};
</script>